document.addEventListener("DOMContentLoaded", () => {
  const sizes = [100, 200, 330, 400, 500, 600, 700, 800, 900];

  const srcsetFrom = (base) => sizes.map((w) => `${base}?width=${w} ${w}w`).join(", ");

  const setTextOrHTML = (el, val) => {
    if (!el || val == null) return;
    if (typeof val === "string" && val.trim().startsWith("<")) el.innerHTML = val;
    else el.textContent = val;
  };

  const getAnchor = (root, selector) => {
    const el = root.querySelector(selector);
    return el ? (el.tagName === "A" ? el : el.querySelector("a")) : null;
  };

  const setAnchorAttrs = (a, id, url) => {
    if (!a) return;
    if (id != null) a.setAttribute("data-id", id);
    if (url) a.setAttribute("href", url);
  };

  // Simple per-card cooldown to avoid thrashing on rapid clicks
  const cooldown = new WeakMap();
  const COOLDOWN_MS = 200;

  // Mobile autoscroll function when 'show less' is clicked
  const autoScrollToSwatchContainer = (swatchContainer) => {
    // Only apply on mobile devices
    if (window.innerWidth > 768) return;
    if (!swatchContainer) return;

    // Get header height from CSS variable or fallback to common values
    const headerHeight = parseInt(getComputedStyle(document.documentElement)
      .getPropertyValue('--header-height')) || 75;

    // Calculate target scroll position
    const containerRect = swatchContainer.getBoundingClientRect();
    const targetY = window.pageYOffset + containerRect.top - headerHeight - 10; // 10px buffer

    // Smooth scroll to position
    window.scrollTo({
      top: Math.max(0, targetY),
      behavior: 'smooth'
    });
  };

  // Reusable function to handle swatch change logic
  const handleSwatchChange = (swatch, card) => {
    const {
      productId,
      collectionIds,
      productUrl,
      productFeaturedImage,
      productTitle: newTitle,
      productPrice: newPrice,
      productComparePrice: newComparePrice,
      hasCompare: hasCompare,
      productHandle: newHandle,
    } = swatch.dataset;

    if (!productUrl || !productFeaturedImage || !productId) return;

    const img = card.querySelector(".t4s-product-img img");
    const imgLink = card.querySelector(".product-image-url");
    const titleLink = card.querySelector(".t4s-product-title a");
    const subtitleEl = card.querySelector(".t4s-product-subtitle");
    const priceEl = card.querySelector(".t4s-product-price");
    const handleEl = card.querySelector(".t4s-product-title a");

    const wishA = getAnchor(card, ".t4s-pr-wishlist");
    const qvA = getAnchor(card, ".t4s-pr-quickview");
    const qsA = getAnchor(card, ".t4s-pr-addtocart");

    if (img && imgLink && titleLink) {
      const src = `${productFeaturedImage}?width=600`;
      const srcset = srcsetFrom(productFeaturedImage);

      img.src = src;
      img.setAttribute("srcset", srcset);
      img.setAttribute("sizes", "auto");
      // img.setAttribute("data-src", src);
      // img.setAttribute("data-srcset", srcset);

      imgLink.href = productUrl;
      titleLink.href = productUrl;
      setTextOrHTML(titleLink, newHandle);
    }

    setTextOrHTML(subtitleEl, newTitle);
    
    if (hasCompare === "true" && priceEl) {
      priceEl.innerHTML = `<del>${newComparePrice}</del><ins>${newPrice}</ins>`;
    } else {
      setTextOrHTML(priceEl, newPrice);
    }

    setTextOrHTML(handleEl, newHandle);

    if (handleEl && handleEl.tagName === "A") handleEl.href = productUrl;

    setAnchorAttrs(wishA, productId, productUrl);
    setAnchorAttrs(qvA, productId, productUrl);
    if (qsA) setAnchorAttrs(qsA, productId, productUrl);

    // Add new badge anchor for the new product
    // But only if there's more than one swatch (otherwise product doesn't change)
    const allSwatches = card.querySelectorAll(".color_swatch");
    if (allSwatches.length > 1) {
      // Find the product-inner container where the original badge anchor is
      const productInner = card.querySelector(".t4s-product-inner");
      
      if (productInner && productId && collectionIds) {
        // Remove old badge anchor(s) if they exist
        const oldAnchors = productInner.querySelectorAll(".lhg-app-badge-anchor");
        oldAnchors.forEach(anchor => anchor.remove());
        
        // Create new badge anchor with updated product data
        const newBadgeAnchor = document.createElement("div");
        newBadgeAnchor.className = "lhg-app-badge-anchor";
        newBadgeAnchor.setAttribute("data-product-id", productId);
        newBadgeAnchor.setAttribute("data-collection-ids", collectionIds);
        newBadgeAnchor.setAttribute("data-badge-location", "product-card");
        
        // Insert the new anchor in the same position (after product image)
        productInner.appendChild(newBadgeAnchor);
      }
    }

    card.querySelectorAll(".color_swatch.active").forEach((s) => s.classList.remove("active"));
    swatch.classList.add("active");
  };

  // Click event listener with cooldown
  document.addEventListener("click", (e) => {
    if (!e.target || typeof e.target.closest !== 'function') return;
    const swatch = e.target.closest(".color_swatches .color_swatch");
    if (!swatch) return;

    const card = swatch.closest(".t4s-product");
    if (!card) return;

    const last = cooldown.get(card) || 0;
    const now = Date.now();
    if (now - last < COOLDOWN_MS) return;
    cooldown.set(card, now);

    handleSwatchChange(swatch, card);
  });

  // Hover event listener without cooldown
  document.addEventListener("mouseenter", (e) => {
    if (!e.target || typeof e.target.closest !== 'function') return;
    const swatch = e.target.closest(".color_swatches .color_swatch");
    if (!swatch) return;

    const card = swatch.closest(".t4s-product");
    if (!card) return;

    handleSwatchChange(swatch, card);
  }, true); // Use capture phase for better performance

  // View More button functionality for custom product swatches
  document.addEventListener("click", (e) => {
    if (!e.target || !e.target.classList || !e.target.classList.contains("view-more-btn")) return;

    const button = e.target;
    const swatchGroup = button.dataset.swatchGroup;
    const swatchContainer = button.closest(".swatch__container");
    const hiddenSwatches = swatchContainer.querySelectorAll(".swatch--hidden");

    button.classList.toggle("expanded");

    hiddenSwatches.forEach(swatch => {
      if (button.classList.contains("expanded")) {
        swatch.style.display = "flex";
      } else {
        swatch.style.display = "none";
      }
    });

    if(!button.classList.contains("expanded")) {
      autoScrollToSwatchContainer(swatchContainer);
    }
  });

  // Color swatches navigation arrows functionality
  const updateArrowStates = (container) => {
    const swatches = container.querySelector('.color_swatches');
    const leftArrow = container.querySelector('.color_swatches__arrow--left');
    const rightArrow = container.querySelector('.color_swatches__arrow--right');

    if (!swatches || !leftArrow || !rightArrow) return;

    // Force layout recalculation to ensure accurate measurements
    swatches.offsetHeight;

    const scrollLeft = swatches.scrollLeft;
    const scrollWidth = swatches.scrollWidth;
    const clientWidth = swatches.clientWidth;

    // More accurate overflow detection
    // Get the actual content width by summing individual swatch widths
    const swatchElements = swatches.querySelectorAll('.color_swatch');
    let totalContentWidth = 0;

    swatchElements.forEach(swatch => {
      const swatchWidth = swatch.offsetWidth;
      const swatchMargin = parseFloat(getComputedStyle(swatch).marginLeft || 0) +
                          parseFloat(getComputedStyle(swatch).marginRight || 0);
      totalContentWidth += swatchWidth + swatchMargin;
    });

    // Add gap between swatches (if any)
    const gap = parseFloat(getComputedStyle(swatches).gap || 0);
    if (swatchElements.length > 1) {
      totalContentWidth += gap * (swatchElements.length - 1);
    }

    // Check if content width exceeds container width
    const containerWidth = swatches.parentElement.offsetWidth - 72; // Subtract arrow space
    const hasOverflow = totalContentWidth > containerWidth;


    // Show/hide arrows based on overflow
    const displayValue = hasOverflow ? 'flex' : 'none';
    leftArrow.style.display = displayValue;
    rightArrow.style.display = displayValue;

    // If no overflow, return early
    if (!hasOverflow) return;

    // Disable left arrow if at the beginning (with small buffer for rounding)
    leftArrow.disabled = scrollLeft <= 5;

    // Disable right arrow if at the end (with small buffer for rounding)
    rightArrow.disabled = scrollLeft >= scrollWidth - clientWidth - 5;
  };

  // Initialize arrow states for all color swatch containers
  const initializeColorSwatchNavigation = () => {
    const containers = document.querySelectorAll('.color_swatches__container');
    containers.forEach(container => {
      // Use setTimeout to ensure DOM is fully rendered
      setTimeout(() => {
        updateArrowStates(container);
      }, 100);
    });
  };

  // Handle arrow clicks
  document.addEventListener('click', (e) => {
    const arrow = e.target.closest('.color_swatches__arrow');
    if (!arrow) return;

    const container = arrow.closest('.color_swatches__container');
    const swatches = container.querySelector('.color_swatches');

    if (!swatches) return;

    const scrollAmount = 100; // Adjust scroll amount as needed
    const isLeftArrow = arrow.classList.contains('color_swatches__arrow--left');

    // Calculate current and target positions
    const currentScrollLeft = swatches.scrollLeft;
    const scrollWidth = swatches.scrollWidth;
    const clientWidth = swatches.clientWidth;
    const maxScrollLeft = Math.max(0, scrollWidth - clientWidth);

    // Calculate target position
    let targetScrollLeft;
    if (isLeftArrow) {
      targetScrollLeft = Math.max(0, currentScrollLeft - scrollAmount);
    } else {
      targetScrollLeft = Math.min(maxScrollLeft, currentScrollLeft + scrollAmount);
    }

    // Only scroll if there's actually a change needed
    if (targetScrollLeft !== currentScrollLeft) {
      swatches.scrollTo({
        left: targetScrollLeft,
        behavior: 'smooth'
      });
    }
  });

  // Update arrow states on scroll
  document.addEventListener('scroll', (e) => {
    if (e.target && e.target.classList && e.target.classList.contains('color_swatches')) {
      const container = e.target.closest('.color_swatches__container');
      updateArrowStates(container);
    }
  }, true);

  // Update arrow states on window resize
  let resizeTimeout;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(() => {
      initializeColorSwatchNavigation();
    }, 100); // Debounce resize events
  });

  // Initialize on DOMContentLoaded
  initializeColorSwatchNavigation();

  // Re-initialize on dynamic content changes (for AJAX-loaded products)
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType === Node.ELEMENT_NODE) {
          const containers = node.querySelectorAll ? node.querySelectorAll('.color_swatches__container') : [];
          if (node.classList && node.classList.contains('color_swatches__container')) {
            // Delay for newly added containers to ensure they're fully rendered
            setTimeout(() => {
              updateArrowStates(node);
            }, 100);
          }
          containers.forEach(container => {
            // Delay for newly added containers
            setTimeout(() => {
              updateArrowStates(container);
            }, 100);
          });
        }
      });
    });
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

  // Use ResizeObserver for more reliable size detection
  if (window.ResizeObserver) {
    const resizeObserver = new ResizeObserver((entries) => {
      entries.forEach((entry) => {
        const container = entry.target.closest('.color_swatches__container');
        if (container) {
          updateArrowStates(container);
        }
      });
    });

    // Observe all color_swatches elements
    document.addEventListener('DOMContentLoaded', () => {
      document.querySelectorAll('.color_swatches').forEach((swatches) => {
        resizeObserver.observe(swatches);
      });
    });

    // Also observe dynamically added elements
    observer.disconnect(); // Disconnect the old observer
    const enhancedObserver = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === Node.ELEMENT_NODE) {
            const containers = node.querySelectorAll ? node.querySelectorAll('.color_swatches__container') : [];
            if (node.classList && node.classList.contains('color_swatches__container')) {
              const swatches = node.querySelector('.color_swatches');
              if (swatches) {
                resizeObserver.observe(swatches);
              }
              setTimeout(() => {
                updateArrowStates(node);
              }, 100);
            }
            containers.forEach(container => {
              const swatches = container.querySelector('.color_swatches');
              if (swatches) {
                resizeObserver.observe(swatches);
              }
              setTimeout(() => {
                updateArrowStates(container);
              }, 100);
            });
          }
        });
      });
    });

    enhancedObserver.observe(document.body, {
      childList: true,
      subtree: true
    });
  }
});
